import React, { useState, useEffect } from 'react';
import './MembershipPopup.css';

const MembershipPopup = ({ isRegisteredUser }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    age: '',
    location: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  useEffect(() => {
    if (isRegisteredUser) return;

    const timer = setInterval(() => {
      setShowPopup(true);
    }, 5 * 60 * 1000); // 5 minutes

    const firstVisitTimer = setTimeout(() => {
      setShowPopup(true);
    }, 5000); // Show after 5 seconds

    return () => {
      clearInterval(timer);
      clearTimeout(firstVisitTimer);
    };
  }, [isRegisteredUser]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    setSubmitSuccess(true);
    setTimeout(() => {
      setShowPopup(false);
      setSubmitSuccess(false);
    }, 3000);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  if (isRegisteredUser || !showPopup) {
    return null;
  }

  return (
    <div className="resort-popup-overlay">
      <div className="resort-popup-container">
        <div className="resort-popup-header">
          <h2>Popular Resort Chain</h2>
          <button className="resort-close-btn" onClick={closePopup}>×</button>
        </div>
        
        <div className="resort-popup-content">
          <div className="resort-highlights">
            <h3>140+ RESORTS</h3>
            <p>Get a call from our holiday expert now!</p>
            <ul className="resort-features">
              <li>✓ 140+ resorts in India & abroad</li>
              <li>✓ 2000+ unique experiences</li>
            </ul>
          </div>
          
          <div className="resort-awards">
            <div className="award-item">
              <strong>Travellers' Choice</strong>
              <span>2023</span>
            </div>
            <div className="award-item">
              <strong>TripAd Travel Choice Award</strong>
              <span>19 Feb 2023</span>
            </div>
          </div>
          
          {submitSuccess ? (
            <div className="resort-success-message">
              <p>Thank you! Our holiday expert will contact you soon.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="resort-membership-form">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Enter phone number"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <input
                  type="text"
                  name="age"
                  placeholder="Age"
                  value={formData.age}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="form-group">
                <input
                  type="text"
                  name="location"
                  placeholder="Where are you from"
                  value={formData.location}
                  onChange={handleInputChange}
                />
              </div>
              
              <button 
                type="submit" 
                className="resort-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          )}
        </div>
        
        <div className="resort-popup-footer">
          <p>Interesting Stories from Our Members</p>
          <small>A family vacation is an album of memories... one that's waiting to be shared.</small>
        </div>
      </div>
    </div>
  );
};

export default MembershipPopup;